module.exports = __webpack_public_path__ + "static/media/JE.a6689095.png";